import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'lista-sanfona-component',
    templateUrl: 'lista-sanfona-component.html',
    styleUrls: ['./lista-sanfona-component.scss']
})

export class ListaSanfonaComponent implements OnInit, AfterViewInit {

    @Output() onSelectFilter = new EventEmitter();
    @Output() onSelectRegion = new EventEmitter();

    @Input() classCSS: string;
    @Input() titulo: string;
    @Input() tipo: string;
    @Input() filter = '';
    @Input() lista: any = [];
    @Input() tituloCols: any = [];
    @Input() updateAt: string;
    filtro: any;
    region = 'Brasil';

    listaAcumulados: any = {};
    listaAcumuladosList: any;

    listaNorte: any[] = [
        {
            createdAt: '2020-03-25T23:37:11.094Z',
            latitude: '-9.97499',
            letalidade: '33',
            longitude: '-67.8243',
            nome: 'Acre',
            objectId: 'uTN8WP10HY',
            percent: '0%',
            qtd_confirmado: 817,
            qtd_incidencia: 926,
            qtd_obito: 29,
            updatedAt: '2020-05-05T22:03:49.539Z'
        }
    ];

    listaNordeste: any[] = [
        {
            createdAt: '2020-03-25T23:37:11.094Z',
            latitude: '-9.97499',
            letalidade: '33',
            longitude: '-67.8243',
            nome: 'Maranhão',
            objectId: 'uTN8WP10HY',
            percent: '0%',
            qtd_confirmado: 817,
            qtd_incidencia: 926,
            qtd_obito: 29,
            updatedAt: '2020-05-05T22:03:49.539Z'
        }
    ];

    listaCentroOeste: any[] = [
        {
            createdAt: '2020-03-25T23:37:11.094Z',
            latitude: '-9.97499',
            letalidade: '33',
            longitude: '-67.8243',
            nome: 'Distrito Federal',
            objectId: 'uTN8WP10HY',
            percent: '0%',
            qtd_confirmado: 817,
            qtd_incidencia: 926,
            qtd_obito: 29,
            updatedAt: '2020-05-05T22:03:49.539Z'
        }
    ];

    listaSul: any[] = [
        {
            createdAt: '2020-03-25T23:37:11.094Z',
            latitude: '-9.97499',
            letalidade: '33',
            longitude: '-67.8243',
            nome: 'Rio Grande do Sul',
            objectId: 'uTN8WP10HY',
            percent: '0%',
            qtd_confirmado: 817,
            qtd_incidencia: 926,
            qtd_obito: 29,
            updatedAt: '2020-05-05T22:03:49.539Z'
        }
    ];

    listaSudeste: any[] = [
        {
            createdAt: '2020-03-25T23:37:11.094Z',
            latitude: '-9.97499',
            letalidade: '33',
            longitude: '-67.8243',
            nome: 'Såo Paulo',
            objectId: 'uTN8WP10HY',
            percent: '0%',
            qtd_confirmado: 817,
            qtd_incidencia: 926,
            qtd_obito: 29,
            updatedAt: '2020-05-05T22:03:49.539Z'
        }
    ];

    detalhe: any;

    constructor() {
        console.log('updateAt-------', this.updateAt);
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this.getAllList();
    }

    formatNumber(num) {
        // console.log('num--------', typeof num)
        if (num) {
            let n = num;
            if (typeof num !== 'string') {
                n = n.toString();
            }
            let r = '';
            let x = 0;

            for (let i = n.length; i > 0; i--) {
                r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
                x = x === 2 ? 0 : x + 1;
            }
            return r.split('').reverse().join('');
        }
    }

    onChangeRegion(region) {
        if (region === 'Brasil') {
            this.listaAcumuladosList = this.listaAcumulados;
        } else {
            if (region === 'Centro Oeste') {
                region = 'Centro-Oeste';
            }
            this.listaAcumuladosList = this.listaAcumulados.filter((item) => {
                return item._id === region;
            });
            if (this.listaAcumuladosList.length) {
                this.openList(this.listaAcumuladosList[0]);
            }
        }

    }

    onfilter(text: any) {
        const search = [];
        if (text) {
            this.listaAcumuladosList = this.listaAcumulados;
            this.listaAcumuladosList.forEach((item, key) => {
                search.push(item);
                if (item.listaMunicipios) {
                    item.listaMunicipios.forEach(element => {
                        search.push(element);
                    });
                }
            });
            let name = [
                {uf: 'AC', nome: 'Acre'},
                {uf: 'AL', nome: 'Alagoas'},
                {uf: 'AP', nome: 'Amapá'},
                {uf: 'AP', nome: 'Amapa'},
                {uf: 'AM', nome: 'Amazonas'},
                {uf: 'BA', nome: 'Bahia'},
                {uf: 'CE', nome: 'Ceará'},
                {uf: 'CE', nome: 'Ceara'},
                {uf: 'DF', nome: 'Distrito Federal'},
                {uf: 'ES', nome: 'Espirito Santo'},
                {uf: 'GO', nome: 'Goiás'},
                {uf: 'GO', nome: 'Goias'},
                {uf: 'MA', nome: 'Maranhão'},
                {uf: 'MA', nome: 'Maranhao'},
                {uf: 'MS', nome: 'Mato Grosso do Sul'},
                {uf: 'MT', nome: 'Mato Grosso'},
                {uf: 'MG', nome: 'Minas Gerais'},
                {uf: 'PA', nome: 'Pará'},
                {uf: 'PB', nome: 'Paraíba'},
                {uf: 'PA', nome: 'Para'},
                {uf: 'PB', nome: 'Paraiba'},
                {uf: 'PR', nome: 'Paraná'},
                {uf: 'PR', nome: 'Parana'},
                {uf: 'PE', nome: 'Pernambuco'},
                {uf: 'PI', nome: 'Piaui'},
                {uf: 'PI', nome: 'Piauí'},
                {uf: 'RJ', nome: 'Rio de Janeiro'},
                {uf: 'RN', nome: 'Rio Grande do Norte'},
                {uf: 'RS', nome: 'Rio Grande do Sul'},
                {uf: 'RO', nome: 'Rondônia'},
                {uf: 'RO', nome: 'Rondonia'},
                {uf: 'RR', nome: 'Roraima'},
                {uf: 'SC', nome: 'Santa Catarina'},
                {uf: 'SP', nome: 'São Paulo'},
                {uf: 'SP', nome: 'Sao Paulo'},
                {uf: 'SE', nome: 'Sergipe'},
                {uf: 'TO', nome: 'Tocantins'}
            ];

            let uf = name.find((item) => (item.nome.toLowerCase().includes(text.toLowerCase())));
            console.log(uf);
            this.listaAcumuladosList = search.filter((item) => {
                if (uf) {
                    return item._id.toLowerCase() == uf.uf.toLowerCase();
                } else {
                    return item._id.toLowerCase().includes(text.toLowerCase());
                }
            });
            this.onSelectFilter.emit(this.filtro);
        } else {
            this.listaAcumuladosList = this.listaAcumulados;
        }
    }

    download() {

    }

    openList(region) {
        console.log(region);
        if (region.regiao === 'Brasil') {
            this.detalhe = null;
            return;
        }

        if (!this.detalhe || (this.detalhe && this.detalhe !== region._id)) {
            this.detalhe = region._id;
        } else if (this.detalhe && this.detalhe === region._id) {
            this.detalhe = null;
        }
    }

    getIncidente(cit) {
        return (cit.casosAcumulado / cit.populacaoTCU2019 * 100000).toFixed(1).replace('.', ',');
    }

    getLetalidade(cit) {
        return (cit.obitosAcumulado / cit.populacaoTCU2019 * 100000).toFixed(1).replace('.', ',');
    }

    getName(cit) {
        if (cit.regiao) {
            return cit.regiao;
        } else {
            return cit._id;
        }
    }

    formatDate(updateAt) {
        this.updateAt = updateAt;
    }

    getAllList() {
        this.listaAcumulados = this.lista;
        this.listaAcumuladosList = this.lista;
        this.updateAt = this.updateAt;
    }
}
